export const QUICK_FILTERS = [
  { key: "in_my_court", label: "In My Court", color: "#1677ff", kind: "flag" },
  { key: "Open", label: "Open", color: "#52c41a", kind: "status" },
  { key: "late", label: "Late", color: "#ff4d4f", kind: "flag" },
];

const isSingleStatusFilterActive = (filters, statusValue) =>
  Array.isArray(filters?.status) &&
  filters.status.length === 1 &&
  filters.status[0] === statusValue;

export const isQuickFilterActive = (filters, filterKey, kind) => {
  if (kind === "status") {
    return isSingleStatusFilterActive(filters, filterKey);
  }
  return Boolean(filters?.[filterKey]);
};

export const toggleQuickFilter = (filters, filterKey, kind) => {
  if (isQuickFilterActive(filters, filterKey, kind)) {
    const nextFilters = { ...filters };
    if (kind === "status") {
      delete nextFilters.status;
    } else {
      delete nextFilters[filterKey];
    }
    return nextFilters;
  }

  if (kind === "status") {
    return {
      ...filters,
      status: [filterKey],
    };
  }

  return {
    ...filters,
    [filterKey]: true,
  };
};
